import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as requests from '../api/requests';
import { addErrorNotification } from './notificationsSlice';

const initialState = {
  redirectUrl: '',
};

// ---------------------- ASYNC THUNKS ----------------------

export const createCheckoutSession = createAsyncThunk(
  'pricing/createCheckoutSession',
  async (amt, thunkAPI) => {
    const res = await requests.createCheckoutSession(amt);
    const body = await res.json();

    if (!res.ok) {
      thunkAPI.dispatch(
        addErrorNotification(
          body.errmsg ||
            'An error occurred while trying to checkout. Please try again later.'
        )
      );
    }

    return { ok: res.ok, body };
  }
);

// ---------------------- SLICE ----------------------

export const pricingSlice = createSlice({
  name: 'pricing',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(createCheckoutSession.fulfilled, (state, { payload }) => {
      if (payload.ok) {
        state.redirectUrl = payload.body.url;
      }
    });
  },
});

export default pricingSlice.reducer;
